import React from "react"
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import { useLocation } from "react-router-dom";

import AccountDropDown from "./account_dropdown"
import SidebarDrawer from "./drawer"

const Header = (props) => {

  const pathname = useLocation().pathname
  const [isOpen, setIsOpen] = React.useState(false)
  const toggleDrawer = () => setIsOpen((prevState) => !prevState)
  const closeDrawer = () => setIsOpen(false)

  const getPageTitle = (path) => {
    if (path === '/organization') return 'Байгууллагын Мэдээлэл'
    else if (path === '/card_info') return 'Картууд'
    else if (path === '/card_charge') return 'Карт цэнэглэлт'
    else if (path === '/card_order') return 'Карт захиалга'
    else if (path === '/report') return 'Тайлан'
    else if (path === '/gstation') return 'ШТС-ын мэдээлэл'

    else if (path === '/help') return 'Тусламж'
    else if (path === '/contact') return 'Холбоо барих'
    return 'Шунхлай'
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="header_top px-4 d-none d-sm-flex d-xl-none">
          <div className="d-flex align-items-center">
            <img src="/images/logo_bg.svg" height={22} />
            <div className="font-weight-bold text-secondary font-size-18 me-2">
              Шунхлай
            </div>
          </div>
        </div>
        <div className="nav-header d-flex justify-content-between align-items-center mx-4 mx-xxl-5">
          <div className="d-flex align-items-center">
            <div className="bordered burger-menu d-flex d-xl-none ms-4" onClick={toggleDrawer}>
              <img src="/images/menu.svg" height={12} />
            </div>
            <div className="header-logo d-flex d-sm-none d-xl-flex">
              <img src="/images/logo_bg.svg" />
              <div className="font-weight-bold text-secondary me-2">
                Шунхлай
              </div>
            </div>
            <div className="font-size-28 font-weight-bold text-black d-none d-sm-block">
              {getPageTitle(pathname)}
            </div>
          </div>
          <div className="d-flex">
            <div className="mx-3 d-none d-lg-block">
              <div className="text-grey font-size-12">РЕГИСТРИЙН ДУГААР</div>
              <div className="font-size-16 ">1849201</div>
            </div>
            <div className="mx-3 d-none d-lg-block">
              <div className="text-grey font-size-12">БАЙГУУЛЛАГЫН НЭР</div>
              <div className="font-size-16">Прокрафт Дизайн Агентлаг</div>
            </div>
            <AccountDropDown />
          </div>
        </div>
      </header>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction='left'
        duration={250}
      >
        <SidebarDrawer onClose={closeDrawer}/>
      </Drawer>
    </React.Fragment>
  );
};

export default Header;
